export const BASELINE_PERMISSIONS = [
  'games.read',
  'markets.read',
  'marketing_assets.read',
  'marketing_assets.download',
  'system.view',
  'users.read',
  'partners.read',
  'permissions.read',
  'roles.read',
];

export const VIEW_COMPLIANCE_DOCUMENTS_PERMISSIONS = [
  'compliance_documents.read',
  'compliance_documents.download',
];

export const SHARE_BASKET_PERMISSIONS = ['shared_baskets.create'];

export const EDIT_CONTACTS_PERMISSIONS = [
  'users.manage_roles',
  'users.manage_permissions',
  'users.update',
  'partners.read',
];
